import IRequest from '../interfaces/IRequest';

export class RequestDocument {
    public readonly data: IRequest;

    public readonly id: string;

    public constructor(id: string, data: IRequest) {
        this.id = id;
        this.data = data;
    }
}

export default RequestDocument;
